export default "__VITE_ASSET__DLfKpD4C__"